import React,{useEffect, useState} from 'react'
import { Header } from './Header'
import { Footer } from './Footer'
// import { Chart } from '../Donut-chart/Chart'
import { Link } from 'react-router-dom'
import site from "../utils/SiteSettings"
import QRCode from "react-qr-code";

//toast
import 'react-toastify/dist/ReactToastify.css'; // import first and after the toastify is work 
import { toast } from 'sonner'


export const Home = () => {

    const [isLoading, setIsLoading] = useState(true)

    const [copyStatus, setCopyStatus] = useState(false);

    const [showButton, setShowButton] = useState(false);

    const Address = site?.site?.tokenAdd
    
    setTimeout(()=>{
        setIsLoading(false)
    },2000)

    const handleCopy = ()=>{
        try {
            // console.log(Address)
            navigator.clipboard.writeText(Address && Address.toString())
            setCopyStatus(true);
            toast.success("Address copied",{position:'top-right'})
            setTimeout(() => setCopyStatus(false), 2000)
        } catch (error) {
            toast.error("Some thing went wrong. please try to copy directly",{position:"top-right"})
            console.log(error)
        }
    }

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth' // Optional, for smooth scrolling
        });
    };

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 550) {
            setShowButton(true);
            } else {
            setShowButton(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll); // Cleanup
    },[]);

  return (
    <>
    {
        isLoading ? (
            <>
                <div >
                    {/* <ThreeDots
                        visible={true}
                    
                        width="80"
                        backgroundColor="#fff"
                        color="#4fa94d"
                        radius="9"
                        ariaLabel="three-dots-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                    /> */}
                    <div id="preloader">
                        <div id="loader">
                            <img src={require("../../assets/logo.png")} alt="loader" />
                        </div>
                    </div>
                </div>
            </>
        ):(
            <>
                <div className='home-text'>
                    <Header />
                    <section id="home" className="section-b-space home-section">
                        <div className="container-fluid">
                            <div className="home-sec">
                                <div className="home-content">
                                    <div>
                                        <h1>Step Into The Future
                                        with {site?.site?.siteName}</h1>
                                     
                                        <p>Full Set of Crypto Products and Services to Build Your Own Web3 Financial System</p>
                                        <p>
                                        {site?.site?.siteName} Decentralized Infrastructure for Crypto Swaps, Payment  gateway, Defi Wallet, Crypto Trade Exchange, Defi Finance, Defi Debit Cards, {site?.site?.siteName} Blockchain, Web 3.0 Ecosystem aiming to redefine global transactions.
                                        </p>
                                        <Link to={'/buy/token'}  className="btn-solid">
                                            Get started 
                                            <i style={{paddingLeft:"3px"}} className="fa-solid fa-arrow-right"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div className="home-img d-lg-flex d-none">
                                    <img  src={require("../../assets/logo-banner.png")} className="img-fluid robot-img" alt="robot" />
                                   
                                </div>
                            </div>
                        </div>
                    </section>
                
                    {/* <!-- service section start --> */}
                    <div className="service-section section-b-space" id="about">
                        <div className="container">
                            <div className="row g-5">
                                <div className="col-lg-6">
                                    <div className="row g-4 service-row">
                                        <div className="col-sm-6">
                                            <div className="service-box">
                                                <div className="service-icon">
                                                    <img src={require("../../assets/svg/home/decent.svg").default} className="img-fluid outline-icon" alt="" />
                                                    <img src={require("../../assets/svg/home/decent.svg").default} className="img-fluid bold-icon" alt="" />
                                                </div>
                                                <div className="service-content">
                                                    <h3>
                                                        <img src={require("../../assets/svg/home/service-title.svg").default} alt="effect" className="img-fluid" />Decentralized 
                                                    </h3>
                                                    <p>Decentralization stands as a foundational principal within blockchain-based cryptocurrencies.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div className="service-box">
                                                <div className="service-icon">
                                                    <img src={require("../../assets/svg/home/security.svg").default} className="img-fluid outline-icon" alt="" />
                                                    <img src={require("../../assets/svg/home/security.svg").default} className="img-fluid bold-icon" alt="" />
                                                </div>
                                                <div className="service-content">
                                                    <h3><img src={require("../../assets/svg/home/service-title.svg").default} alt="effect"
                                                            className="img-fluid" />Security</h3>
                                                    <p>{site?.site?.siteName} is strategically constructing a certainty-driven ecosystem, underpinned by robust credit scoring architecture.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div className="service-box">
                                                <div className="service-icon">
                                                    <img src={require("../../assets/svg/home/sustain.svg").default} className="img-fluid outline-icon" alt="" />
                                                    <img src={require("../../assets/svg/home/sustain.svg").default} className="img-fluid bold-icon" alt="" />
                                                </div>
                                                <div className="service-content">
                                                    <h3><img src={require("../../assets/svg/home/service-title.svg").default} alt="effect" className="img-fluid" />Sustainability</h3>
                                                    <p>{site?.site?.siteName} ecosystem champions sustainable evolution through the fundamental principle of consensus.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div className="service-box">
                                                <div className="service-icon">
                                                    <img src={require("../../assets/svg/home/text.svg").default} className="img-fluid outline-icon" alt="" />
                                                    <img src={require("../../assets/svg/home/text.svg").default} className="img-fluid bold-icon" alt="" />
                                                </div>
                                                <div className="service-content">
                                                    <h3><img src={require("../../assets/svg/home/service-title.svg").default} alt="effect"
                                                            className="img-fluid" />Low cost & High Efficiency
                                                            Buy {site?.site?.siteName}</h3>
                                                    <p>{site?.site?.siteName} attains its objectives by leveraging a decentralized operational support infrastructure. 
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="service-info">
                                        <div>
                                            <div className="title">
                                                <h2>About {site?.site?.siteName}</h2>
                                                <h3 className='mb-4'>Ecosystem Empowering Crypto Derivatives</h3>
                                                <h3>Full Set of Crypto Products and Services to Build Your Own Web3 Financial System</h3>
                                            </div>
                                           
                                            <p> {site?.site?.siteName} represents an innovative platform aiming to establish a fully decentralized finance ecosystem, effectively closing the divide between the realm of cryptocurrencies and conventional fiat applications like Payment gateway, wallets, transaction, Merchants, swap, exchange, Debit cards.</p>
                                            <div className="vision-sec">
                                            <h4>Vision</h4>
                                                <ul>
                                                    <li><img src={require("../../assets/svg/home/tick-white.svg").default} className="img-fluid" alt="tick"/> Complete decentralized Infrastructure</li>
                                                    <li><img src={require("../../assets/svg/home/tick-white.svg").default} className="img-fluid" alt="tick"/>Security</li>
                                                    <li><img src={require("../../assets/svg/home/tick-white.svg").default} className="img-fluid" alt="tick"/> Freedom of money globally</li>
                                                    <li><img src={require("../../assets/svg/home/tick-white.svg").default} className="img-fluid" alt="tick"/> Flexibility</li>
                                                </ul>
                                            </div>
                                           

                                            <div data-cursor="pointer" className="btn-arrow" href="/buy/token">
                                                {/* <div className="icon-arrow"><i class="fa-solid fa-arrow-right"></i></div>Buy Coinstirs */}
                                                <Link to={'/buy/token'}  className="btn-solid">
                                                    Buy {site?.site?.siteName}
                                                    <i style={{paddingLeft:"3px"}} className="fa-solid fa-arrow-right"></i>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <!-- service section end --> */}
                    
                    {/* <!-- about section start --> */}
                    <section className="about-section section-b-space section-mb-space" id="feature">
                        <div className="bg-effect" data-aos="fade-left" data-aos-duration="1000" data-aos-delay="500"></div>
                        <div className="container">
                            <div className="row g-md-5 g-4">
                                <div className="col-lg-6 order-lg-0 order-1">
                                    <div className="about-content">
                                        <div>
                                            <div className="title">
                                            
                                                <h2 className="">{site?.site?.siteName} Ecosystem
                                                </h2>
                                            </div>
                                            <p>{site?.site?.siteName} represents an innovative platform aiming to establish a fully decentralized finance ecosystem, effectively closing the divide between the realm of cryptocurrencies and conventional fiat.</p>
                                            <ul>
                                                <li><img src={require("../../assets/svg/home/tick-white.svg").default} className="img-fluid" alt="tick"/>Ecosystem of Crypto Trade Exchange
                                                </li>
                                                <li><img src={require("../../assets/svg/home/tick-white.svg").default} className="img-fluid" alt="tick"/>Payment Gateway 
                                                </li>
                                                <li><img src={require("../../assets/svg/home/tick-white.svg").default} className="img-fluid" alt="tick"/>{site?.site?.siteName} Blockchain
                                                </li>
                                                <li><img src={require("../../assets/svg/home/tick-white.svg").default} className="img-fluid" alt="tick"/>Defi Wallets

                                                </li>
                                                <li><img src={require("../../assets/svg/home/tick-white.svg").default} className="img-fluid" alt="tick"/>{site?.site?.siteName} Swap

                                                </li>
                                                <li><img src={require("../../assets/svg/home/tick-white.svg").default} className="img-fluid" alt="tick"/>Defi Finance

                                                </li>
                                                <li><img src={require("../../assets/svg/home/tick-white.svg").default} className="img-fluid" alt="tick"/>Defi Debit Cards

                                                </li>
                                                <li><img src={require("../../assets/svg/home/tick-white.svg").default} className="img-fluid" alt="tick"/>Web 3.0 Ecosystem

                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="about-img">

                                        <img src={require("../../assets/about-banner.png")} className="img-fluid" alt="about" />
                                        {/* <img src={require('../../assets/1.svg').default}/> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    {/* <!-- about section end --> */}

                    {/* <!-- about section start --> */}
                    <section className="about-section right-version section-b-space section-mb-space">
                        <div className="bg-effect"  data-aos="fade-right" data-aos-duration="1000" data-aos-delay="500"></div>
                        <div className="container">
                            <div className="row g-md-5 g-4 align-items-center">
                                <div className="col-lg-6">
                                    <div className="about-img">
                                        <img src={require("../../assets/svg/home/2.svg").default} className="img-fluid" alt="about" />
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="about-content">
                                        <div>
                                            <div className="title">
                                                
                                                <h2>Real-World Crypto Adoption
                                                </h2>
                                            </div>
                                            <p>{site?.site?.siteName} is committed to bridging the gap between the crypto realm and real-life utility. Our mission extends beyond digital transactions, as we believe in bringing cryptocurrency to the forefront of everyday experiences. We understand that true adoption goes beyond the virtual realm, and that's why we're pioneering real-life integration like never before.</p>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    {/* <!-- about section end --> */}

                    {/* <!-- about section start --> */}
                    <section className="about-section section-b-space" id="token">
                        <div className="bg-effect" data-aos="fade-left" data-aos-duration="1000" data-aos-delay="500"></div>
                        <div className="container">
                            <div className="row g-md-5 g-4 align-items-center">
                                <div className="col-lg-6 order-lg-0 order-1">
                                    <div className="about-content">
                                        <div>
                                            <div className="title">
                                                <h2 className="">Tokenomics</h2>
                                            </div>
                                            <p>{site?.site?.siteName} stands as a dynamic DeFi token built upon the BNB Smart Chain, adhering to the BEP-20 standard. With a total supply of 1 billion (1,000,000,000), {site?.site?.siteName} powers the {site?.site?.siteName} ecosystem, driving decentralized transactions and fuelling the innovative financial solutions that define our platform's essence.</p>
                                            {/* <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,</p> */}
                                            <div className="row">
                                            <div className=" col-lg-6">
                                            <ul>
                                                <li>
                                                    <img src={require("../../assets/svg/home/tick-white.svg").default} className="img-fluid" alt="tick"/>
                                                    Presale <br/>
                                                    (200,000,000-20%)
                                                </li>
                                                <li>
                                                    <img src={require("../../assets/svg/home/tick-white.svg").default} className="img-fluid" alt="tick" />
                                                    Ecosystem Allocation <br/>
                                                    (100,000,000-10%)
                                                </li>
                                                <li>
                                                    <img src={require("../../assets/svg/home/tick-white.svg").default} className="img-fluid" alt="tick" />
                                                    {site?.site?.siteName} Buy-Back & Burn Plan <br/>
                                                    (400,000,000-40%)
                                                </li>
                                                <li>
                                                    <img src={require("../../assets/svg/home/tick-white.svg").default} className="img-fluid" alt="tick" />
                                                    Liquidity & Listings Reserve <br/>
                                                    (80,000,000-8%)
                                                </li>
                                                <li>
                                                    <img src={require("../../assets/svg/home/tick-white.svg").default} className="img-fluid" alt="tick" />
                                                    MM, Incentives, KOL’s <br/>
                                                    (30,000,000-3%)
                                                </li>
                                            </ul>
                                            </div>
                                            <div className="row col-lg-6">
                                            <ul>
                                                <li>
                                                    <img src={require("../../assets/svg/home/tick-white.svg").default} className="img-fluid" alt="tick"/>
                                                    Team <br/>
                                                    (80,000,000-8%)
                                                </li>
                                                <li>
                                                    <img src={require("../../assets/svg/home/tick-white.svg").default} className="img-fluid" alt="tick" />
                                                    Cashback Reserve <br/>
                                                    (40,000,000-4%)
                                                </li>
                                                <li>
                                                    <img src={require("../../assets/svg/home/tick-white.svg").default} className="img-fluid" alt="tick" />
                                                    Partners & Advisors <br/>
                                                    (30,000,000-3%)
                                                </li>
                                                <li>
                                                    <img src={require("../../assets/svg/home/tick-white.svg").default} className="img-fluid" alt="tick" />
                                                    Marketing, Acquisitions, Partnerships <br/>
                                                    (40,000,000-4%)
                                                </li>
                                            </ul>
                                            </div>
                                            </div>
                                            
                                            
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                <div className="">
                                    <div className="about-img">
                                        <img src={require("../../assets/tokenomics.png")} className="img-fluid tokenomics" alt="about" />
                                        {/* <Chart /> */}
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    {/* <!-- about section end --> */}

                    {/* <!-- feature section start --> */}
                    <section className="feature-section section-b-space">
                        <div className="bg-effect">
                            <img src={require("../../assets/images/feature.gif")} className="img-fluid feature-left" alt="" />
                            <img src={require("../../assets/images/feature.gif")}  className="img-fluid feature-right" alt=""/>
                            {/* <img  src={require("../../assets/images/feature-bg.gif")} class="img-fluid feature-bg" alt=""/> */}
                            <span className="round-effect"></span>
                        </div>
                        <div className="container">
                            <div className="title-basic">
                                <h2>{site?.site?.siteName} Ecosystem</h2>
                            </div>
                            <div className="swiper featureSlider">
                                <div id="featureSlider" className="swiper-wrapper">
                                    <div className="swiper-slide">
                                        <div className="row g-xxl-5 g-4">
                                            <div className="col-xl-4 col-lg-4 col-sm-6">
                                                <div className="feature-box">
                                                    <div className="feature-top">
                                                        <div className="feature-icon">
                                                            <img src={require("../../assets/svg/home/message.svg").default} className="img-fluid outline-icon" alt=""/>
                                                            <img src={require("../../assets/svg/home/message-bold.svg").default} className="img-fluid bold-icon" alt=""/>
                                                        </div>
                                                        <h3>{site?.site?.siteName} EXCHANGE
                                                        </h3>
                                                    </div>
                                                    <h4>
                                                        <p className="flex flex-col" style={{ display: 'flex', flexDirection: 'column' }}>
                                                            {site?.site?.siteName} was born out of a notion to bring analogue financial services into a purely digital space. 
                                                        </p>
                                                    </h4>
                                                </div>
                                            </div>
                                            <div className="col-xl-4 col-lg-4 col-sm-6">
                                                <div className="feature-box">
                                                    <div className="feature-top">
                                                        <div className="feature-icon">
                                                            <img src={require("../../assets/svg/home/code.svg").default} className="img-fluid outline-icon" alt=""/>
                                                            <img src={require("../../assets/svg/home/code-bold.svg").default} className="img-fluid bold-icon" alt=""/>
                                                        </div>
                                                        <h3>PAYMENT GATEWAY 
                                                        </h3>
                                                    </div>
                                                    <h4>
                                                        <p className="flex flex-col" style={{ display: 'flex', flexDirection: 'column' }}>
                                                            Seamlessly accept cryptocurrencies in your online business, expanding payment options for your customers.
                                                        </p>
                                                    </h4>
                                                </div>
                                            </div>
                                            <div className="col-xl-4 col-lg-4 col-sm-6">
                                                <div className="feature-box">
                                                    <div className="feature-top">
                                                        <div className="feature-icon">
                                                            <img src={require("../../assets/svg/home/play.svg").default} className="img-fluid outline-icon" alt=""/>
                                                            <img src={require("../../assets/svg/home/play-bold.svg").default} className="img-fluid bold-icon"  alt=""/>
                                                        </div>
                                                        <h3>SWAP AGGREGATOR
                                                        </h3>
                                                    </div>
                                                    <h4>
                                                        <p className="flex flex-col" style={{ display: 'flex', flexDirection: 'column' }}>
                                                            Effortlessly find the most favourable rates by instantly comparing quotes and fees across various decentralized exchanges (DEXes).
                                                        </p>
                                                    </h4>
                                                </div>
                                            </div>
                                            <div className="col-xl-4 col-lg-4 col-sm-6">
                                                <div className="feature-box">
                                                    <div className="feature-top">
                                                        <div className="feature-icon">
                                                            <img src={require("../../assets/svg/home/insta1.svg").default} className="img-fluid outline-icon" alt=""/>
                                                            <img src={require("../../assets/svg/home/insta-bold.svg").default} className="img-fluid bold-icon" alt=""/>
                                                        </div>
                                                        <h3>DeFi WALLET
                                                        </h3>
                                                    </div>
                                                    <h4>
                                                        <p className="flex flex-col" style={{ display: 'flex', flexDirection: 'column' }}>
                                                            A secure, non-custodial wallet supporting multiple blockchains, providing you full control over your assets.
                                                        </p>
                                                    </h4>
                                                </div>
                                            </div>
                                            <div className="col-xl-4 col-lg-4 col-sm-6">
                                                <div className="feature-box">
                                                    <div className="feature-top">
                                                        <div className="feature-icon">
                                                            <img src={require("../../assets/svg/home/mail.svg").default} className="img-fluid outline-icon" alt=""/>
                                                            <img src={require("../../assets/svg/home/mail-bold.svg").default} className="img-fluid bold-icon" alt=""/>
                                                        </div>
                                                        <h3>DeFi DEBIT CARDS
                                                        </h3>
                                                    </div>
                                                    <h4>
                                                        <p className="flex flex-col" style={{ display: 'flex', flexDirection: 'column' }}>
                                                            Prioritize your financial privacy with anonymous transactions and ensure security with {site?.site?.siteName} DeFi Debit Cards.
                                                        </p>
                                                    </h4>
                                                </div>
                                            </div>
                                            <div className="col-xl-4 col-lg-4 col-sm-6">
                                                <div className="feature-box">
                                                    <div className="feature-top">
                                                        <div className="feature-icon">
                                                            <img src={require("../../assets/svg/home/hashtag.svg").default} className="img-fluid outline-icon" alt=""/>
                                                            <img src={require("../../assets/svg/home/hashtag-bold.svg").default}  className="img-fluid bold-icon" alt=""/>
                                                        </div>
                                                        <h3>DeFi FINANCE 
                                                        </h3>
                                                    </div>
                                                    <h4>
                                                        <p className="flex flex-col" style={{ display: 'flex', flexDirection: 'column' }}>
                                                            Let our powerful AI analyse lending options for you, ensuring you get the best and most profitable lending solutions.
                                                        </p>
                                                    </h4>
                                                </div>
                                            </div>
                                        
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    
                        <div className="swiper-pagination feature-pagination"></div>
                    </section>
                    {/* <!-- feature section end --> */}

                    {/* <!-- faq section start --> */}
                    <section className="faq-section">
                        <div className="container">
                            <div className="title-basic">
                                <h2 className="">FAQ</h2>
                            </div>
                            <div className="accordion" id="accordionPanelsStayOpenExample">
                                <div className="accordion-item">
                                    <h2 className="accordion-header" id="panelsStayOpen-headingOne">
                                        <button data-cursor="pointer" className="accordion-button" type="button" data-bs-toggle="collapse"
                                            data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="true"
                                            aria-controls="panelsStayOpen-collapseOne">
                                            What is {site?.site?.siteName} Ecosystem?
                                        </button>
                                    </h2>
                                    <div id="panelsStayOpen-collapseOne" className="accordion-collapse collapse show"
                                        aria-labelledby="panelsStayOpen-headingOne">
                                        <div className="accordion-body">
                                            <p>{site?.site?.siteName}  is a DeFi ecosystem that provides a variety of financial tools and services, including Crypto exchange, swap, DeFi debit cards, smart payment gateways, secure Defi wallet, Defi Finance, Blockchain and a web 3.0 ecosystem. It aims to redefine how people conduct financial transactions in the digital age.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="accordion-item">
                                    <h2 className="accordion-header" id="panelsStayOpen-headingTwo">
                                        <button data-cursor="pointer" className="accordion-button collapsed" type="button"
                                            data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseTwo" aria-expanded="false"
                                            aria-controls="panelsStayOpen-collapseTwo">
                                            What is {site?.site?.siteName} Token?
                                        </button>
                                    </h2>
                                    <div id="panelsStayOpen-collapseTwo" className="accordion-collapse collapse"
                                        aria-labelledby="panelsStayOpen-headingTwo">
                                        <div className="accordion-body">
                                            {site?.site?.siteName} is a community-driven governance token for the {site?.site?.siteName} Ecosystem, allowing token holders to participate in decision-making processes and help shape the future of the {site?.site?.siteName} ecosystem.
                                        </div>
                                    </div>
                                </div>
                                <div className="accordion-item">
                                    <h2 className="accordion-header" id="panelsStayOpen-headingThree">
                                        <button data-cursor="pointer" className="accordion-button collapsed" type="button"
                                            data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseThree"
                                            aria-expanded="false" aria-controls="panelsStayOpen-collapseThree">
                                            How and where I can buy {site?.site?.siteName} Token?
                                        </button>
                                    </h2>
                                    <div id="panelsStayOpen-collapseThree" className="accordion-collapse collapse"
                                        aria-labelledby="panelsStayOpen-headingThree">
                                        <div className="accordion-body">
                                            Visit {site?.site?.siteName} signup and buy {site?.site?.siteName} token.
                                        </div>
                                    </div>
                                </div>
                                <div className="accordion-item">
                                    <h2 className="accordion-header" id="panelsStayOpen-headingFour">
                                        <button data-cursor="pointer" className="accordion-button collapsed" type="button"
                                            data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseFour"
                                            aria-expanded="false" aria-controls="panelsStayOpen-collapseFour">
                                            How many presale stages are there?
                                        </button>
                                    </h2>
                                    <div id="panelsStayOpen-collapseFour" className="accordion-collapse collapse"
                                        aria-labelledby="panelsStayOpen-headingFour">
                                        <div className="accordion-body">
                                            {site?.site?.siteName} presale consists of 4 stages. For additional details, please visit: https://{site?.site?.siteFullName}/presale.No, there is no inherent limit to the amount of stuff you can create. The possibilities are
                                        </div>
                                    </div>
                                </div>
                                <div className="accordion-item">
                                    <h2 className="accordion-header" id="panelsStayOpen-headingFive">
                                        <button data-cursor="pointer" className="accordion-button collapsed" type="button"
                                            data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseFive"
                                            aria-expanded="false" aria-controls="panelsStayOpen-collapseFive">
                                            When and where will {site?.site?.siteName} launch?
                                        </button>
                                    </h2>
                                    <div id="panelsStayOpen-collapseFive" className="accordion-collapse collapse"
                                        aria-labelledby="panelsStayOpen-headingFive">
                                        <div className="accordion-body">
                                            {site?.site?.siteName} token is scheduled to list on both centralized (CEX) and decentralized (DEX) exchanges on Dec1st, 2025. Stay tuned for official announcements about the specific launch time and trading platforms by following our social media channels.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    {/* <!-- faq section end --> */}

                    {/* <!-- contact us start --> */}
                    <section className="info-section section-b-space">
                        <div className="container">
                            <div className="info-box" data-aos="fade-in" data-aos-duration="1000" data-aos-delay="100">
                                <div className="hand-effect d-md-block d-none">
                                    {/* <img src={require("../../assets/svg/home/hand.svg").default} className="img-fluid left-hand" alt="hand" />
                                    <img src={require("../../assets/svg/home/hand.svg").default} className="img-fluid right-hand" alt="hand"/> */}
                                </div>
                                <h2>Token Contract

                                </h2>
                                
                                <ul>
                                    <li>
                                        <QRCode size={256} className="img-fluid qr-code" style={{ height: "100px", width: "100px" }} value={Address && Address} />
                                        {/* <img src={require("../../assets/svg/home/copy.svg").default} className="img-fluid" alt="tick"/> */}
                                        Address <br/>
                                        {/* 0x78E4464A96Db4BcC65259E705460A624A23d34E8 */}
                                        {Address && Address}
                                        {/* <img src={require("../../assets/svg/home/copy.svg").default} className="img-fluid" alt="tick"/> */}
                                       
                                        {copyStatus === false ?  <svg width="16" height="16" viewBox="0 0 16 16" className='copy-img' onClick={handleCopy} fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M6 1.75H12.75H14.25V3.25V10H12.75V3.25H6V1.75ZM9.75 6.25H3.25V12.75H9.75V6.25ZM1.75 4.75V14.25H11.25V4.75H1.75Z" fill="#ffffff"></path>
                                        </svg> :  <p><i className="fa-solid fa-square-check"></i></p>}
                                    </li>
                                    <li>
                                        <img src={require("../../assets/svg/home/tick-white.svg").default}  className="img-fluid" alt="tick"/>
                                        Decimal <br/>
                                        18
                                    </li>
                                    <li>
                                        <img src={require("../../assets/svg/home/tick-white.svg").default} className="img-fluid" alt="tick"/>
                                        Network <br/>
                                        Binance Chain
                                        (BEB20)
                                    </li>
                                    <li>
                                        <img src={require("../../assets/svg/home/tick-white.svg").default} className="img-fluid" alt="tick"/>
                                        Token Symbol <br/>
                                        {site?.site?.siteName}
                                    </li>
                                    {/* <li>
                                        <QRCode size={256} className="img-fluid qr-code" style={{ height: "100px", width: "100px" }} value="0x78E4464A96Db4BcC65259E705460A624A23d34E8" />
                                    </li> */}
                                </ul>
                                {/* <a data-cursor="pointer" className="btn-arrow" href="/buy/token">
                                    Buy Now
                                </a> */}
                                <div className='d-flex justify-content-center'>
                                    <div data-cursor="pointer" className="btn-arrow" href="/buy/token">
                                                {/* <div className="icon-arrow"><i class="fa-solid fa-arrow-right"></i></div>Buy Coinstirs */}
                                                <Link to={'/buy/token'}  className="btn-solid">
                                                    Buy {site?.site?.siteName}
                                                    <i style={{paddingLeft:"3px"}} className="fa-solid fa-arrow-right"></i>
                                                </Link>
                                            </div>
                                </div>
                                
                            </div>
                        </div>
                    </section>
                    {/* <!-- contact us end --> */}

                    <Footer />

                    {/* <!-- Tap To Top Button Start --> */}
                    {
                        showButton && (
                        <div  className="tap-to-top-box ">
                                <button  onClick={scrollToTop} className="tap-to-top-button"><i className="fa-solid fa-chevron-up"/></button>
                            </div>
                        )
                    }
                    {/* <!-- Tap To Top Button End --> */}

                    </div>
            </>    
        )
    }
    
    </>
  )
}
